/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerCreateMutationRequest, DepartmentsControllerCreateMutationResponse, DepartmentsControllerCreate400, DepartmentsControllerCreate401, DepartmentsControllerCreate403 } from "../../models/departmentsController/DepartmentsControllerCreate";

function getDepartmentsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/departments` as const }  
  return res
}

/**
 * @summary Create a new department
 * {@link /api/v1/departments}
 */
export async function departmentsControllerCreate(data?: DepartmentsControllerCreateMutationRequest, config: Partial<RequestConfig<DepartmentsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<DepartmentsControllerCreateMutationResponse, ResponseErrorConfig<DepartmentsControllerCreate400 | DepartmentsControllerCreate401 | DepartmentsControllerCreate403>, DepartmentsControllerCreateMutationRequest>({ method : "POST", url : getDepartmentsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}